/**
 * home/sections/FooterSection.tsx
 * Pie de página — DS v2 alineado con hero-v2.html
 *
 * @version 2.3.0
 * @changes
 *   F2.01: enlace /legal añadido al footer-nav
 *   FAQ-04: enlace guía calidad + FAQ añadidos al footer-nav
 *   CONV-UX: button usa className en lugar de all:unset; Links sin color:inherit
 */
import type { FC } from 'react';
import { Link } from 'react-router-dom';

interface FooterSectionProps {
  onOpenConversor?: () => void;
}

export const FooterSection: FC<FooterSectionProps> = ({ onOpenConversor }) => (
  <footer className="site-footer">
    <div className="footer-inner">

      <div className="footer-brand">
        <span className="footer-logo">PTEL&nbsp;<span>Tool</span></span>
        <span className="footer-brand-desc">Normalización de coordenadas para emergencias</span>
      </div>

      <nav className="footer-nav">
        <a
          href="https://github.com/luismgarcia/norm-coord-ptel"
          target="_blank"
          rel="noopener noreferrer"
        >
          GitHub
        </a>
        <span className="footer-nav-sep">·</span>
        <a href="mailto:lmg.grea.epc@juntadeandalucia.es?cc=luismugor%40gmail.com">Contacto</a>
        <span className="footer-nav-sep">·</span>
        <Link to="/faq" className="footer-nav-link">
          FAQ
        </Link>
        <span className="footer-nav-sep">·</span>
        <a
          href="/guia-calidad.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          Guía de calidad
        </a>
        <span className="footer-nav-sep">·</span>
        {onOpenConversor ? (
          <button
            type="button"
            onClick={onOpenConversor}
            className="footer-nav-btn"
          >
            Conversor UTM
          </button>
        ) : (
          <a href="/guia-calidad.html#obtener" target="_blank" rel="noopener noreferrer">
            Conversor UTM
          </a>
        )}
        <span className="footer-nav-sep">·</span>
        <Link to="/transparencia" className="footer-nav-link">
          Transparencia
        </Link>
        <span className="footer-nav-sep">·</span>
        <Link to="/legal" className="footer-nav-link">
          Legal
        </Link>
      </nav>

    </div>

    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
      <div className="footer-decree">
        <span className="footer-decree-text">
          2025-2026 PTEL Tool · Herramienta en desarrollo · Sin carácter oficial
        </span>
        <div className="footer-decree-badges">
          <span className="footer-badge footer-badge-teal">EPSG:25830</span>
          <span className="footer-badge footer-badge-lime">UTM30 ETRS89</span>
        </div>
      </div>
    </div>
  </footer>
);

export default FooterSection;
